/* eslint-disable react/require-default-props */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import PagesContainer from "src/components/shared/molecules/PagesContainer";
import PendingSkeleton from "src/components/pages/dashboard/skeleton/dashboard/PendingTable";
import { UseDashboardContext } from "src/context/dashboard";
// import Badge, { BadgeProps } from "@mui/material/Badge";
// import { styled } from "@mui/material/styles";
import useStyles from "./Styles";

interface IProps {
  title?: string;
  source?: string;
}

const ListContainer: React.FC<IProps> = ({
  title,
  source,
}: {
  title?: string;
  source?: string;
}) => {
  const { classes } = useStyles();

  const [, setPendingCount] = useState(0);
  const [pendingPages, setPendingPages] = useState<any[]>([]);
  const contextData = UseDashboardContext();
  let totalChatsGraphDataLoading: boolean = false;
  let totalChatsGraphData: any;

  if (contextData) {
    ({ totalChatsGraphData, totalChatsGraphDataLoading } = contextData);
  }
  useEffect(() => {
    if (totalChatsGraphData) {
      const list: React.SetStateAction<any[]> = [];
      let count = 0;
      totalChatsGraphData.forEach((item: any) => {
        if (item.source === source) {
          list.push(item);
          count += 1;
        }
      });
      setPendingPages(list);
      setPendingCount(count);
    }
  }, [totalChatsGraphData, source]);

  return totalChatsGraphDataLoading ? (
    <Box sx={{ padding: "30px", width: "100%" }}>
      <PendingSkeleton />
    </Box>
  ) : (
    <Box className={classes.gridItems}>
      <Box className={classes.pagesContainer}>
        <PagesContainer
          title={title}
          dataList={pendingPages}
          source={source}
          chatTitle="breakdown"
        />
      </Box>
    </Box>
  );
};

export default ListContainer;
